import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input, Label } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { PinDeSeguranca } from "@/components/pin/PinDeSeguranca";
import { senhaNovaSchema } from "@bookdental/schemas";

/** Senha de acesso e PIN de sócio. */
export function SegurancaSecao() {
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const { signOut } = useAuth();
  const alterar = trpc.me.alterarSenha.useMutation({
    // O servidor encerra todas as sessões (inclusive em outros aparelhos); entrar de novo agora
    // evita a sessão cair sozinha daqui a um minuto.
    onSuccess: () => {
      toast.success("Senha alterada. Entre de novo com a nova senha.");
      setTimeout(() => void signOut(), 1500);
    },
    onError: (e) => toast.error(e.message || "Não foi possível alterar a senha."),
  });

  const regra = nova ? senhaNovaSchema.safeParse(nova) : null;
  const erro =
    regra && !regra.success
      ? regra.error.issues[0]?.message
      : confirma && nova !== confirma
        ? "A confirmação não bate com a nova senha."
        : null;
  const pode = !!atual && !!regra?.success && nova === confirma && !alterar.isPending;

  return (
    <div className="space-y-6 px-6 py-5">
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          if (pode) alterar.mutate({ atual, nova });
        }}
      >
        <div className="flex items-center gap-2">
          <KeyRound className="h-4 w-4 text-zinc-500" />
          <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Trocar senha</h3>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          <div className="space-y-1.5">
            <Label htmlFor="senha-atual">Senha atual</Label>
            <Input id="senha-atual" type="password" autoComplete="current-password" value={atual} onChange={(e) => setAtual(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="senha-nova">Nova senha</Label>
            <Input id="senha-nova" type="password" autoComplete="new-password" value={nova} onChange={(e) => setNova(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="senha-confirma">Confirmar nova senha</Label>
            <Input id="senha-confirma" type="password" autoComplete="new-password" value={confirma} onChange={(e) => setConfirma(e.target.value)} />
          </div>
        </div>
        {erro && <p className="text-xs text-red-600 dark:text-red-400">{erro}</p>}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={!pode}
            className="inline-flex h-9 items-center gap-1.5 rounded-md bg-brand-600 px-4 text-[12.5px] font-semibold text-white shadow-sm transition-colors hover:bg-brand-700 disabled:opacity-50"
          >
            {alterar.isPending && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
            Alterar senha
          </button>
        </div>
      </form>

      <div className="border-t border-zinc-100 pt-5 dark:border-border">
        <PinDeSeguranca />
      </div>
    </div>
  );
}
